<template>
  <div>
    <v-simple-table
      v-if="files.length"
      class="mb-2"
    >
      <template v-slot:default>
        <tbody>
          <tr
            v-for="file in files"
            :key="file.id"
          >
            <td>
              <v-btn
                text
                icon
                x-small
                color="red"
                @click.prevent="$refs.upload.remove(file)"
              >
                <v-icon>{{ mdiMinusCircleOutline }}</v-icon>
              </v-btn>
            </td>
            <td>
              <div class="filename">
                {{ file.name }}
              </div>
              <div
                v-if="file.active || file.progress !== '0.00'"
              >
                <v-progress-linear
                  :value="file.progress"
                  :color="file.error ? 'red' : 'primary'"
                />
              </div>
            </td>

            <td v-if="file.success">
              <v-icon color="primary">
                {{ mdiCheckCircle }}
              </v-icon>
            </td>
            <td v-else />
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-btn
      outlined
      color="grey darken-2"
      class="mt-3"
      @click="onAddFile"
    >
      {{ $t('Box.uploadFile') }}
    </v-btn>

    <file-upload
      ref="upload"
      name="file"
      :post-action="postUrl"
      :extensions="extensions"
      :accept="accept"
      :multiple="multiple"
      :size="size || 0"
      :drop="drop"
      :headers="{'Authorization': `Bearer ${this.$g2eOauth.token}`}"
      :maximum="maximum || 0"
      @input-filter="inputFilter"
      @input-file="inputFile"
      @input="inputUpdate"
    />
  </div>
</template>

<style scoped>
  .file-uploads {
    display: inline-flex;
  }
</style>

<script>
import boxFileVuex from '../store/modules/box/file'
import store from '../store'
import { mapState, mapGetters } from 'vuex'
import { boxFileModule } from '../store/moduleName'
import FileUpload from 'vue-upload-component'
import { mdiMinusCircleOutline, mdiCheckCircle } from '@mdi/js'

if (!store.state[boxFileModule]) store.registerModule(boxFileModule, boxFileVuex)

export default {
  components: {
    FileUpload
  },
  filters: {
    formatSize: function (val) {
      return Math.round(val / 1024) + 'KB'
    }
  },
  props: {
    postUrl: {
      type: String,
      required: true
    },
    extensions: {
      type: String,
      default: 'gif,jpg,jpeg,png,webp'
    },
    accept: {
      type: String,
      default: 'image/png,image/gif,image/jpeg,image/webp'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 0
    },
    maximum: {
      type: Number,
      default: 0
    },
    drop: {
      type: Boolean,
      default: true
    },
    thread: {
      type: Number,
      default: 3
    },
    uploadAuto: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mdiMinusCircleOutline: mdiMinusCircleOutline,
    mdiCheckCircle: mdiCheckCircle
  }),
  computed: {
    ...mapState({
      files: state => state[boxFileModule].files
    }),
    ...mapGetters(boxFileModule, {
      successFileCnt: 'successCnt'
    })
  },
  created () {
    this.$store.commit(boxFileModule + '/clearFiles')
  },
  methods: {
    inputFilter (newFile, oldFile, prevent) {
      // console.log('inputFilter: ' + newFile)
      if (newFile && !oldFile) {
        if (!/^[a-zA-Z0-9\s_-]+\.(bmp|png|jpeg|jpg|gif|txt|doc|docx|pdf|xls|xlsx|ppt|zip|rar|rtf)$/i.test(newFile.name)) {
          alert(newFile.name + ': ' + this.$t('Box.fileRemark3'))
          return prevent()
        }
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile (newFile, oldFile) {
      // console.log('inputFile: ' + newFile)
      if (newFile && !oldFile) {
        // add
        // console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        // console.log('update', newFile)

        // Upload error
        if (newFile.error !== oldFile.error) {
          console.log('error', newFile.error, newFile)
        }

        // 上传成功
        if (newFile.success !== oldFile.success) {
          // console.log('success', newFile.success, newFile.response.uploadFileId)
          // console.log(this.files)
        }
      }
      if (!newFile && oldFile) {
        // remove
        // console.log('remove', oldFile)
      }

      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    onAddFile () {
      let label = this.$refs.upload.$el.querySelector('label')
      label.click()
    },
    inputUpdate (files) {
      // console.log('files inputUpdate: ' + JSON.stringify(files))
      this.$store.commit(boxFileModule + '/updateFiles', files)
    }
  }
}
</script>
